import * as Styled from "./Order.styles";

import OrderedItem, { ItemProps } from "./OrderItem";

import { Collapse } from "@mui/material";
import { TabItemData } from "@utils/getTabFeed/getTabFeed";
import { TransitionGroup } from "react-transition-group";

interface OrderItemProps {
  items: ItemProps[] | TabItemData[];
}

function OrderList({ items }: OrderItemProps): React.ReactElement {
  return (
    <Styled.ListContainer className="order-list" spacing={1}>
      <TransitionGroup role="group">
        {items.map((item, index) => (
          <Collapse key={`order-item-${index}`} role="listitem">
            <OrderedItem item={item} index={index} />
          </Collapse>
        ))}
      </TransitionGroup>
    </Styled.ListContainer>
  );
}

export default OrderList;
